<template>
  <div class="order-list-box">
    <div class="has-order">
      <div class="order-table">
        <div class="table-header">
          <div v-if="isPc" class="pcTitle">
             <span>订单信息</span>
             <span>订单号：{{orderNo}}</span>
          </div>
          <div v-else>订单信息</div>
        </div>
        <order-item :item-list="orderInfo.itemList"></order-item>
        <div class="table-footer">
          <div class="total-price">
            合计：
            <span>¥{{ orderInfo.totalPrice }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付 -->
    <Pay @click="getPayType" isFrom='hotel'></Pay>


    <div v-if="isPc" class="btn-bottom">
      <div class="right-btn" @click="pay">订单无误 去支付</div>
    </div>
    <div v-else  class="btn-bottom">
      <div class="left-btn" @click="toBack">上一步</div>
      <div class="right-btn" @click="pay">提交订单</div>
    </div>
    <payModel v-if="isok" @closeMolel="closeMolel" :orderNo="this.orderNo" isfrom="hotel"></payModel>
  </div>
</template>

<script>
import Pay from '../../components/pay/index.vue'
import orderItem from './components/order_item'
import payModel from '../../components/payModel/index.vue'
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  name: "orderInfo",
  components: { orderItem, Pay,payModel },
  data() {
    return {
      hasOrder: true,
      btnText: '立刻预定',
      orderInfo: {
        orderNo: '000123456789',
        orderTime: '2020-07-24',
        totalMoney: '3600.00',
        status: '已支付',
        itemList: [
          {
            name: '南京国际青年会议酒店',
            room: ' 标准间',
            size: '整间',
            date: '2020-08-21至 2020-08-23',
            price: '800',
            people: '张晶超1 男'
          },
          {
            name: '南京国际青年会议酒店',
            room: ' 标准间',
            size: '整间',
            date: '2020-08-21至 2020-08-23',
            price: '800',
            people: '张晶超2 男'
          },
          {
            name: '南京国际青年会议酒店',
            room: ' 标准间',
            size: '整间',
            date: '2020-08-21至 2020-08-23',
            price: '400',
            people: '张晶超3 男'
          }
        ]
      },
      orderInfo2: {
        orderNo: '000123456710',
        orderTime: '2020-08-25',
        totalMoney: '1200.00',
        status: '未支付',
        itemList: [
          {
            name: '南京国际青年会议酒店',
            room: ' 标准间',
            size: '整间',
            date: '2020-08-21至 2020-08-23',
            price: '800',
            people: '张晶超1 男'
          },
          {
            name: '南京国际青年会议酒店',
            room: ' 标准间',
            size: '整间',
            date: '2020-08-21至 2020-08-23',
            price: '400',
            people: '张斯琳 女 '
          },
        ]
      },
      orderNo: '',
      isok: false
    }
  },
  methods: {
    getPayType(type) {
      this.orderInfo.payType = type
    },
    toBack() {
      this.$router.go(-1)
    },
    async toNext() {
      const data = {
        amount: this.orderInfo.totalPrice,
        audienceId: localStorage.getItem('audienceId'),
        payType: this.orderInfo.payType,
        meetingId: this.meetingId,
        hotelOrderDetails: this.orderInfo.itemList
      }
      const res = await http.post(apis.submitBookOrder, data)
      if (res.code === 0) {
        this.$alert('预订成功', '',{
            showClose: false
        })
        this.$store.commit('SET_CURRENT_ROOM', {})
        this.$store.commit('SET_CURRENT_HOTEL', {})
        this.$router.push('/pay_success')
      } else {
        this.$alert(res.msg, '',{
          showClose: false
        })
      }

    },
    async pay() {
        const data = {
            orderNo: localStorage.getItem('hotelOrderNo'),
            payType: parseInt(this.orderInfo.payType)
        }
        if(!this.orderInfo.payType){
            this.$alert('请先选择支付方式', '',{
                showClose: false
            })
            return
        }
        if(this.orderInfo.payType == 1){
            this.$alert('暂不支持该支付方式', '',{
                showClose: false
            })
            return
        }
        if ( this.isPc) {
            if(this.orderInfo.payType == 2){
                data.tradeType = 'NATIVE'
            }else{
                data.tradeType = 'ONSITE'
            }
        }
        if(!this.isPc) {
            var is_weixin = (function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 })();
            if(is_weixin&&this.orderInfo.payType == 2) {
                data.tradeType = 'JSAPI'
                data.openId = localStorage.getItem('openId')
            }else{
                if(this.orderInfo.payType == 2) {
                    data.tradeType = 'MWEB'
                }else{
                    data.tradeType = 'ONSITE'
                }
                
            }
        }
        const res = await http.get('/renren-fast/app/hotel/hotelPay', {params: data})
        if(res.code===0) {
            if(this.isPc && this.orderInfo.payType ==2){
              localStorage.setItem('payurl',res.payResult.codeUrl)
              // 生成二维码-
              this.$router.push("/pc_pay?type=hotel")
            }else{
              const vm = this
              var is_weixin = (function () { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 })();
              if(is_weixin && this.orderInfo.payType==2) {
                console.log('微信支付  移动端微信内部')
                var prepay_id;
                var appId = res.payResult.appId;
                var sign = res.payResult.paySign;
                var timeStamp = res.payResult.timeStamp;
                var nonceStr = res.payResult.nonceStr;
                var packageStr = res.payResult.packageValue; //没有
                var signType = res.payResult.signType;
                //调起微信支付控件
                callpay();
                function onBridgeReady() {
                  WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', {
                    "appId": appId,     //公众号名称，由商户传入
                    "paySign": sign,         //微信签名
                    "timeStamp": timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": nonceStr, //随机串
                    "package": packageStr,  //预支付交易会话标识
                    "signType": signType     //微信签名方式
                  },
                    function (res) {
                      //alert(JSON.stringify(res));
                      if (res.err_msg == "get_brand_wcpay_request:ok") {
                        //window.location.replace("index.html");
                        vm.$router.push('/pay_success')
                      } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                        alert('支付取消');
                      } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                        alert('支付失败');
                      }
                      //使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                    }
                  );
                }

                function callpay() {
                  if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                    } else if (document.attachEvent) {
                      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                    }
                  } else {
                    onBridgeReady();
                  }
                }
              }else{
                if(this.orderInfo.payType ==1 || this.orderInfo.payType ==2 ){
                    console.log(this.orderInfo.payType)
                    window.location.href = res.payResult.mwebUrl
                }else{
                    console.log(this.orderInfo.payType, 'ele')
                    this.$router.push('/pay_success')
                }
                
              }
            }
        }else{
            alert("下单失败");
        }
    },
    closeMolel() {
         this.isok=false
    },
    async getOrderList() {
        const params = {
            orderNo: this.orderNo
        }
        const res = await http.get(`/renren-fast/app/hotel/getHotelOrder/${this.meetingId}`, {params})
        const orderInfo = res.hotelOrder
        orderInfo.itemList = []
        orderInfo.totalPrice = 0
        orderInfo.hotelOrderVO.forEach((item) => {
          orderInfo.totalPrice +=  item.amount
          item.hotelOrderDetailsEntities.forEach((roomItem) => {
            orderInfo.itemList.push({
              hotelName: roomItem.hotelName,
              startDate: roomItem.startDate,
              endDate: roomItem.endDate,
              gender: roomItem.gender,
              customerName: roomItem.customerName,
              hotelType: roomItem.hotelType,
              sellType: roomItem.sellType,
              price: roomItem.price,
              roomPrice: item.roomPrice,
              bedPrice: item.bedPrice,
              hotelRoomId: item.id
            })
          })
        })
        this.orderInfo = orderInfo
    }
  },
  computed: {
    isPc() {
      return this.$store.state.isPc
    },
    currentRoom() {
      return this.$store.state.currentRoom
    },
    meetingId() {
      return this.$store.state.meetingId || localStorage.getItem('meetingId')
    }
  },
  created() {
    console.log('currentRoom', this.currentRoom)
    this.isok = this.$route.query.isback==1
    this.orderNo = localStorage.getItem('hotelOrderNo')
    if(this.isok){
       this.getOrderList()
    }
    const orderInfo = this.currentRoom
    orderInfo.itemList = []
    orderInfo.roomList.forEach((item) => {
      item.roomList.forEach((roomItem) => {
        orderInfo.itemList.push({
          hotelName: item.hotelName,
          startDate: item.startDate,
          endDate: item.endDate,
          gender: roomItem.gender,
          customerName: roomItem.customerName,
          hotelType: item.hotelType,
          sellType: item.sellType,
          price: item.sellType === 0 ? item.roomPrice : item.bedPrice,
          roomPrice: item.roomPrice,
          bedPrice: item.bedPrice,
          hotelRoomId: item.id
        })
      })
    })
    this.orderInfo = orderInfo
    console.log('orderInfo', this.orderInfo)
  }
}
</script>

<style lang="stylus" scoped>
.order-list-box {
  /*padding: 24px 0px 100px 0px;*/
  padding-bottom: 100px;
}

.btn-blue {
  background-color: #2852a6;
  color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 10px;
  width: 242px;
  text-align: center;
  font-size: 27px;
  margin: 60px auto 0px auto;
}

.no-order {
  font-size: 30px;
  color: #000;
  text-align: center;
  margin-top: 100px;
}

.order-table {
  background-color: #fff;
  border: 1px solid #cfcfcf;
  box-shadow: 0px 0px 5px 2px #cfcfcf;
  border-radius: 20px;
  padding: 0px 20px;
  margin-top: 30px;

  .table-header {
    font-size: 29px;
    color: #000;
    height: 84px;
    line-height: 84px;
    text-align: center;
  }

  .table-footer {
    height: 84px;
    line-height: 84px;
    font-size: 29px;

    .total-price {
      text-align: right;
      color: #000;

      span {
        color: #ff4e00;
        font-size: 31px;
      }
    }
  }
}

.btn-bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  display: flex;
  text-align: center;

  .left-btn {
    background-color: #d5d5d5;
    width: 30%;
  }

  .right-btn {
    width: 70%;
    color: #ffffff;
    background-color: #2852A6;
  }
}

@media screen and (min-width: 800px) {
  .order-list-box {
    overflow hidden
    padding: 0;
    position: relative;
    width: 900px;
    margin: 0 auto;
    min-height: 100vh;
    background: #f1f1f1;
    box-sizing: border-box;
    padding-bottom: 100px;
  }

  .btn-blue {
    background-color: #2852a6;
    color: #fff;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    width: 242px;
    text-align: center;
    font-size: 20px;
    margin: 60px auto 0px auto;
  }

  .no-order {
    font-size: 30px;
    color: #000;
    text-align: center;
    margin-top: 100px;
  }

  .order-table {
    background-color: #fff;
    border: 1px solid #cfcfcf;
    box-shadow: 0px 0px 5px 2px #cfcfcf;
    border-radius: 20px;
    padding: 10px 30px;
    margin-top: 30px;

    .table-header {
      font-size: 18px;
      color: #000;
      height: 40px;
      line-height: 40px;
      .pcTitle{
        display flex
        justify-content space-between
      }
    }

    .table-footer {
      height: 84px;
      line-height: 84px;
      font-size: 22px;

      .total-price {
        text-align: left ;
        color: #000;

        span {
          color: #ff4e00;
          font-size: 20px;
        }
      }
    }
  }

  .btn-bottom {
    position: fixed;
    left: 50%;
    bottom: 10px;
    transform translateX(-50%)
    width: 316px;
    height: 60px;
    line-height: 60px;
    font-size: 20px;
    display: flex;
    text-align: center;


    .left-btn {
      background-color: #d5d5d5;
      width: 30%;
    }

    .right-btn {
      width: 100%;
      color: #ffffff;
      border-radius 10px
    }
  }
}
</style>
